export const CHECKOUT_BREAKDOWN = "Checkout Breakdown";
export const SUBTOTAL = "Subtotal";
export const PACKAGE_SAVINGS = "Package savings";
export const SEAT_SELECTION = "Seat selection";
export const TOTAL_DUE_TODAY = "Total due today";
export const HOTEL_SERVICE_FEE = "Hotel service fee";
